/**
 * Question12 in adobexd
 */
import React, { useContext, useEffect, useState } from "react";

import {
  Back,
  Hero,
  LinearGradient,
  Next,
  Stages,
} from "../../../../components";

import { Container, Section, NavigateButtons } from "./styles";
import { NavigateButtonsContext, DataUserContext } from "../..";
import { ThemeContext, DefaultTheme } from "styled-components";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";
import { sendDatalessStep } from "../../../../services/data-service/api";

const Question11: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { token } = useContext(DataUserContext);
  const [error, setError] = useState(0);

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 12);
  }, []);

  function submit()
  {
    sendDatalessStep('etapa_timeline_informativa', token);

    next(15);
  }

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_timeline_informativa.propriedades.imagens.etapa_timeline_informativa_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_timeline_informativa.propriedades.banner.subtituloBanner"
            )}
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_timeline_informativa.propriedades.conteudo.titulo"
              )}
            </p>

            <p>
              {can(
                theme,
                "theme.steps.etapa_timeline_informativa.propriedades.conteudo.timeline.subtitulo"
              )}
            </p>

            <Stages theme={theme} />
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question11;
